module.exports = __webpack_public_path__ + "img/M-ON-1.f944b1ca.gif";